import { isEmpty } from "ramda";

// can we move this into some utils type?
export const flattenForAnalytics = (data) => {
	const result = {};

	// delete the action key element from the data
	if (data && data.actionKey) {
		data.actionKey = undefined;
	}

	if (!data || isEmpty(data)) {
		return result;
	}

	const recurse = (cur, prop) => {
		if (Object(cur) !== cur) {
			result[prop] = cur;
		} else if (Array.isArray(cur)) {
			const len = cur.length;
			cur.forEach((e, i) => {
				recurse(cur[i], prop ? `${prop}_${i}` : `${i}`);
				if (len === 0) {
					result[prop] = [];
				}
			});
		} else {
			let isEmpty = true;

			for (const p in cur) {
				isEmpty = false;
				recurse(cur[p], prop ? `${prop}_${p}` : p);
			}
			if (isEmpty) {
				result[prop] = {};
			}
		}
	};
	recurse(data, "");
	return result;
};

export const clone = (obj) => {
	let copy;

	// Handle the 3 simple types, and null or undefined
	if (obj == null || typeof obj !== "object") return obj;

	// Handle Date
	if (obj instanceof Date) {
		copy = new Date();
		copy.setTime(obj.getTime());
		return copy;
	}

	// Handle Array
	if (Array.isArray(obj)) {
		copy = [];

		for (let i = 0, len = obj.length; i < len; i++) {
			copy[i] = clone(obj[i]);
		}
		return copy;
	}

	// Handle Object
	if (obj instanceof Object) {
		copy = {};

		for (const attr in obj) {
			if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
		}
		return copy;
	}

	throw new Error("Unable to copy obj! Its type isn't supported.");
};

export const removeEmpty = (obj) => {
	if (obj) {
		const newObj = {};
		Object.keys(obj).forEach((key) => {
			const cur = obj[key];
			if (cur && Array.isArray(cur)) {
			} else if (cur && typeof cur === "object") {
				const v = removeEmpty(cur);
				if (Object.keys(v).length > 0) {
					newObj[key] = v; // recurse
				}
			} else if (cur != null) {
				newObj[key] = cur; // copy value
			}
		});
		return newObj;
	}
	return obj;
};
